module.exports = __webpack_public_path__ + "static/media/google-app.2020d235.png";